(() => {
  const euroLocale = () => document.documentElement.lang?.startsWith('de') ? 'de-DE'
    : document.documentElement.lang?.startsWith('en') ? 'en-IE' : 'sl-SI';
  const euroAmount = (raw) => {
    const compact = raw.replace(/[\s\u00a0\u202f]/g, '');
    const decimal = compact.match(/([.,])(\d{1,2})$/);
    return decimal
      ? Number(compact.slice(0, -(decimal[2].length + 1)).replace(/[.,]/g, '') + '.' + decimal[2])
      : Number(compact.replace(/[.,]/g, ''));
  };
  const formatEuroAmount = (amount) => new Intl.NumberFormat(euroLocale(), {
    style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2,
  }).format(amount);
  const formatEuroText = (text) => text.replace(
    /€\s*(\d+(?:[.,]\d+|[ \u00a0\u202f]\d{3})*)(?:\s*EUR\b)?|(\d+(?:[.,]\d+|[ \u00a0\u202f]\d{3})*)\s*€(?:\s*EUR\b)?/g,
    (match, before, after) => {
      const amount = euroAmount(before || after);
      return Number.isFinite(amount) ? formatEuroAmount(amount) : match;
    }
  );
  const priceTextSelector = '.price, .price-item, .k-bundles__price, .k-card-price, .k-cart-completion__copy > span, .k-cart-shipping__copy, .totals__total-value, .cart-item__details > .product-option, .cart-item__old-price, .cart-item__final-price, .cart-item__totals, .discounts__discount, .k-cart-sticky-checkout strong, #cart-live-region-text, [data-k-selection-price], [data-k-sticky-price]';
  const formatPriceNodes = (root) => {
    root.querySelectorAll(priceTextSelector).forEach((element) => {
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach((node) => {
        if (node.parentElement?.closest('script, style, textarea, [contenteditable]')) return;
        const text = formatEuroText(node.textContent);
        if (text !== node.textContent) node.textContent = text;
      });
    });
  };

  const syncStickyPurchase = (root) => {
    const sectionId = root.dataset.sectionId;
    const productInfo = document.getElementById(`MainProduct-${sectionId}`);
    const canonicalButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const stickyButton = root.querySelector('[data-k-sticky-submit]');

    if (!productInfo || !canonicalButton || !stickyButton) return;

    const update = () => {
      const canonicalLabel = canonicalButton.querySelector('span')?.textContent?.trim();
      if (canonicalLabel && stickyButton.textContent.trim() !== canonicalLabel) stickyButton.textContent = canonicalLabel;
      if (stickyButton.disabled !== canonicalButton.disabled) stickyButton.disabled = canonicalButton.disabled;
    };

    stickyButton.addEventListener('click', () => canonicalButton.click());
    new MutationObserver(update).observe(canonicalButton, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
      characterData: true,
    });

    root.hidden = false;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        root.classList.toggle('is-primary-visible', entry.isIntersecting);
        root.inert = entry.isIntersecting;
      }, { threshold: 0.5 }).observe(canonicalButton);
    }
    update();
  };

  const normalizeOfferCopy = (productInfo) => {
      const title = productInfo.querySelector('.Avada-Volume__HeaderTitle-Text');
      const group = productInfo.querySelector('.Avada-VolumeItem__Container');
      const locale = document.documentElement.lang?.slice(0, 2) || 'sl';
      const recommendedLabel = locale === 'de' ? 'Empfohlen' : locale === 'en' ? 'Recommended' : 'Priporočena izbira';
      const isBundle = /\/(paket-odpornost-energija|zimska-lekarna)\/?$/.test(productInfo.dataset.url || window.location.pathname);
      if (title) {
        let terms = productInfo.querySelector('[data-k-volume-terms]');
        if (!terms) {
          terms = document.createElement('p');
          terms.dataset.kVolumeTerms = '';
          terms.className = 'k-volume-terms';
          title.parentElement.after(terms);
        }
        const text = locale === 'de'
          ? (isBundle ? 'Mengenrabatt für gleiche Sets. Angezeigt wird der Gesamtpreis.' : 'Mengenrabatt für dasselbe Produkt, auch mit unterschiedlichen Größen. Angezeigt wird der Gesamtpreis.')
          : locale === 'en'
            ? (isBundle ? 'Quantity discounts apply to the same set. Prices shown are totals.' : 'Quantity discounts apply to the same product, including mixed sizes. Prices shown are totals.')
            : (isBundle ? 'Popust velja za več enakih paketov. Prikazane so skupne cene.' : 'Popust velja za isti izdelek, tudi v različnih velikostih. Prikazane so skupne cene.');
        if (terms.textContent !== text) terms.textContent = text;
      }
      if (isBundle) {
        const bundleHeading = locale === 'de' ? 'Anzahl der Sets' : locale === 'en' ? 'Number of sets' : 'Število paketov';
        if (title && title.textContent !== bundleHeading) title.textContent = bundleHeading;
        if (group && group.getAttribute('aria-label') !== bundleHeading) group.setAttribute('aria-label', bundleHeading);
        productInfo.querySelectorAll('.Avada-Volume__Info--TriggerQty > span:first-child').forEach((label) => {
          const quantity = Number(label.textContent.match(/\b(\d+)\b/)?.[1]);
          if (!quantity) return;
          const text = locale === 'de' ? `${quantity} ${quantity === 1 ? 'Set' : 'Sets'}`
            : locale === 'en' ? `${quantity} ${quantity === 1 ? 'set' : 'sets'}`
              : `${quantity} ${quantity === 1 ? 'paket' : quantity === 2 ? 'paketa' : 'paketi'}`;
          if (label.textContent !== text) label.textContent = text;
        });
      }

      if (title?.textContent.trim() === 'Kupi več, in privarčuj') {
        title.textContent = 'Kupi več in privarčuj';
      }
      if (group?.getAttribute('aria-label') === 'Kupi več, in privarčuj') {
        group.setAttribute('aria-label', 'Kupi več in privarčuj');
      }

      productInfo.querySelectorAll('.Avada-BadgeText').forEach((badge) => {
        if (/najbolj\s*prodajano|best\s*seller|bestseller/i.test(badge.textContent)) {
          badge.textContent = recommendedLabel;
        }
      });
    };

  const chooseSingleJarOffer = (productInfo) => {
    let checks = 0;
    let customerChangedOffer = false;

    const labelTextFor = (input) => {
      if (input.matches('[role="radio"]')) return input.textContent.replace(/\s+/g, ' ').trim();
      const label = input.id ? productInfo.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
      return `${label?.textContent || ''} ${input.getAttribute('aria-label') || ''}`
        .replace(/\s+/g, ' ')
        .trim();
    };

    const markCustomerChoice = (event) => {
      if (
        event.isTrusted &&
        event.target instanceof Element &&
        event.target.closest('.Avada-Bundle-Volume__Container [role="radio"], .Avada-Bundle-Volume__Container input[type="radio"], .Avada-Bundle-Volume__Container [role="combobox"]')
      ) {
        customerChangedOffer = true;
      }
    };

    productInfo.addEventListener('pointerdown', markCustomerChoice, { passive: true });
    productInfo.addEventListener('change', markCustomerChoice);
    productInfo.addEventListener('keydown', markCustomerChoice);

    let selectionTimer;
    const selectSingleOffer = () => {
      normalizeOfferCopy(productInfo);
      if (customerChangedOffer || checks >= 24) {
        window.clearInterval(selectionTimer);
        selectionObserver.disconnect();
        return;
      }

      const singleOffer = [...productInfo.querySelectorAll('.Avada-Volume__Item')]
        .find((offer) => {
          const label = offer.querySelector('.Avada-Volume__Info--TriggerQty > span:first-child')?.textContent;
          const quantity = Number(label?.match(/\b(\d+)\b/)?.[1]);
          return quantity === 1 || offer.querySelectorAll('.Avada-Volume__Product').length === 1;
        });
      const singleJar = singleOffer?.querySelector('[role="radio"]') ||
        [...productInfo.querySelectorAll('input[type="radio"], [role="radio"]')].find((input) =>
          /(?:kupi|buy|kaufen?)\s*1\b|1\s*(?:kozarec|jar|glas)/i.test(labelTextFor(input))
        );

      if (!singleJar) return;
      selectionObserver.disconnect();

      const isSelected = singleJar.checked || singleJar.getAttribute('aria-checked') === 'true';
      if (isSelected) return;

      singleJar.click();
    };
    // React as soon as the app renders, before showing its default two-jar
    // selection for a timer tick. Never override an actual customer choice.
    const selectionObserver = new MutationObserver(selectSingleOffer);
    selectionObserver.observe(productInfo, { childList: true, subtree: true });
    selectionTimer = window.setInterval(() => { checks += 1; selectSingleOffer(); }, 350);
    selectSingleOffer();
  };

  const initPurchaseSelection = (productInfo) => {
    const selectionSummary = productInfo.querySelector('[data-k-selection-summary]');
    const sectionId = productInfo.id.replace(/^MainProduct-/, '');
    const stickyPurchase = document.querySelector(
      `[data-k-sticky-purchase][data-section-id="${CSS.escape(sectionId)}"]`
    );
    if (!selectionSummary && !stickyPurchase) return;

    const locale = document.documentElement.lang?.slice(0, 2) || 'sl';
    const productPath = productInfo.dataset.url || window.location.pathname;
    const isBundle = /\/(paket-odpornost-energija|zimska-lekarna)\/?$/.test(productPath);
    let scheduled = false;

    const normalizeSize = (value = '') =>
      value
        .replace(/\s+/g, ' ')
        .replace(/(\d)\s*[x×]\s*(?=\d)/gi, '$1 × ')
        .replace(/(\d)\s*g\b/gi, '$1 g')
        .trim();

    const pluralRules = new Intl.PluralRules('sl');

    const localizeEuroText = formatEuroText;

    const localizeOfferPrices = () => {
      const recommendedLabel = locale === 'de' ? 'Empfohlen' : locale === 'en' ? 'Recommended' : 'Priporočena izbira';
      productInfo.querySelectorAll('.Avada-BadgeText').forEach((badge) => {
        if (/najbolj\s*prodajano|best\s*seller|bestseller/i.test(badge.textContent)) {
          badge.textContent = recommendedLabel;
        }
      });
      productInfo.querySelectorAll('[id^="price-"] :is(.price-item--regular, .price-item--sale)').forEach((price) => {
        if (!price.children.length && price.textContent.includes('€')) {
          const localized = localizeEuroText(price.textContent).replace(/\s+EUR\b/g, '').trim();
          if (localized !== price.textContent) price.textContent = localized;
        }
      });
      const offer = productInfo.querySelector('.Avada-Bundle-Volume__Container');
      if (!offer) return;

      const walker = document.createTreeWalker(offer, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);
      textNodes.forEach((node) => {
        if (!node.textContent) return;
        let localized = node.textContent;
        if (locale === 'de') localized = localized.replace(/\bSave\b/g, 'Spare');
        if (locale === 'sl') localized = localized.replace(/\bPrice\b/g, 'Cena').replace(/\bWas\b/g, 'Prej').replace(/\bnow\b/g, 'zdaj');
        if (localized.includes('€')) localized = localizeEuroText(localized);
        if (localized !== node.textContent) node.textContent = localized;
      });
    };

    const selectedSize = () => {
      const checkedOptions = [...productInfo.querySelectorAll('.product-form__input input[type="radio"]:checked')];
      const checked = checkedOptions[checkedOptions.length - 1];
      if (checked) {
        return normalizeSize(checked.value);
      }

      const selectedOptions = [...productInfo.querySelectorAll('.product-form__input select')]
        .map((select) => select.selectedOptions?.[0]?.textContent)
        .filter(Boolean);
      const selected = selectedOptions[selectedOptions.length - 1];
      return normalizeSize(selected || '');
    };

    const selectedOffer = () => {
      const explicit = productInfo.querySelector(
        '.Avada-Volume__Item--Selected, .Avada-Volume__Item[aria-checked="true"]'
      );
      if (explicit) return explicit;
      return [...productInfo.querySelectorAll('.Avada-ItemTier')].find((item) =>
        item.querySelector('.Avada-ItemRadioBtn.-selected')
      );
    };

    const offerQuantity = (offer) => {
      const count = offer?.querySelectorAll('.Avada-Volume__Product').length;
      if (count) return count;
      const explicit = offer?.querySelector('.Avada-Volume__Info--TriggerQty > span:first-child')?.textContent;
      const fromLabel = Number(explicit?.match(/\b(\d+)\b/)?.[1]);
      if (Number.isInteger(fromLabel) && fromLabel > 0) return fromLabel;
      const nativeQuantity = Number(productInfo.querySelector('input[name="quantity"]')?.value);
      return Number.isInteger(nativeQuantity) && nativeQuantity > 0 ? nativeQuantity : 1;
    };

    const offerLabel = (quantity) => {
      if (locale === 'de') return `${quantity} ${isBundle ? (quantity === 1 ? 'Set' : 'Sets') : (quantity === 1 ? 'Glas' : 'Gläser')}`;
      if (locale === 'en') return `${quantity} ${isBundle ? (quantity === 1 ? 'set' : 'sets') : (quantity === 1 ? 'jar' : 'jars')}`;
      const category = pluralRules.select(quantity);
      const labels = isBundle
        ? { one: 'paket', two: 'paketa', few: 'paketi', other: 'paketov' }
        : { one: 'kozarec', two: 'kozarca', few: 'kozarci', other: 'kozarcev' };
      return `${quantity} ${labels[category]}`;
    };

    const selectedOfferSizes = (offer) => {
      if (isBundle) return selectedSize();
      const sizes = [...(offer?.querySelectorAll('.Avada-Volume__Product') || [])].map((item) => {
        const selected = [...item.querySelectorAll('.Avada-VariantSelection__SelectedText')]
          .map((value) => normalizeSize(value.textContent)).filter(Boolean);
        return selected.join(' / ') || selectedSize();
      }).filter(Boolean);
      if (!sizes.length) return selectedSize();
      const counts = new Map();
      sizes.forEach((size) => counts.set(size, (counts.get(size) || 0) + 1));
      if (counts.size === 1) return sizes[0];
      return [...counts].map(([size, count]) => `${count} × ${size}`).join(' + ');
    };

    const visiblePrice = (offer) => {
      const offerPrice = offer?.querySelector('.AOV-Offer__DiscountPrice')?.textContent?.trim();
      if (offerPrice) return localizeEuroText(offerPrice);
      const priceContainer = productInfo.querySelector('[id^="price-"]');
      const canonicalPrice = priceContainer
        ?.querySelector(priceContainer.querySelector('.price--on-sale') ? '.price-item--sale' : '.price-item--regular')
        ?.textContent?.trim();
      if (!canonicalPrice) return '';
      const quantity = offerQuantity(offer);
      if (!offer && quantity > 1) {
        const raw = canonicalPrice.match(/\d[\d.,\s\u00a0]*/)?.[0]?.replace(/\s/g, '') || '';
        const amount = Number(raw.replace(/[.,](?=\d{3}(?:[.,]|$))/g, '').replace(',', '.'));
        const currency = document.querySelector('meta[property="og:price:currency"]')?.content || 'EUR';
        if (raw && Number.isFinite(amount)) {
          return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount * quantity);
        }
      }
      return localizeEuroText(canonicalPrice).replace(/\s+EUR\s*$/, '');
    };

    const setText = (element, value) => {
      if (element && value && element.textContent !== value) element.textContent = value;
    };

    const syncSizeDisclosures = () => {
      if (isBundle) return;
      productInfo.querySelectorAll('.Avada-Volume__Item').forEach((item, index) => {
        const options = item.querySelector('.Avada-Volume__Products');
        if (!options || options.querySelectorAll('.Avada-Volume__Product').length < 2) return;
        // This class is observed below. Re-adding it every frame creates a
        // MutationObserver -> requestAnimationFrame loop even while idle.
        if (!item.classList.contains('k-has-size-options')) {
          item.classList.add('k-has-size-options');
        }
        let toggle = item.querySelector('.k-size-options-toggle');
        if (!toggle) {
          toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'k-size-options-toggle';
          options.id = `k-size-options-${sectionId}-${index}`;
          toggle.setAttribute('aria-controls', options.id);
          options.before(toggle);
        }
        const expanded = item.classList.contains('k-size-options-open');
        toggle.setAttribute('aria-expanded', String(expanded));
        setText(toggle, locale === 'de'
          ? (expanded ? 'Größenauswahl schließen' : 'Größen einzeln wählen')
          : locale === 'en'
            ? (expanded ? 'Close size options' : 'Choose sizes separately')
            : (expanded ? 'Zapri izbiro velikosti' : 'Izberi velikost za vsak kozarec'));
      });
    };

    productInfo.addEventListener('click', (event) => {
      const toggle = event.target.closest?.('.k-size-options-toggle');
      if (!toggle) return;
      toggle.closest('.Avada-Volume__Item').classList.toggle('k-size-options-open');
      syncSizeDisclosures();
    });

    const update = () => {
      scheduled = false;
      normalizeOfferCopy(productInfo);
      localizeOfferPrices();
      syncSizeDisclosures();

      const offer = selectedOffer();
      if (offer) {
        const quantityInput = productInfo.querySelector('input[name="quantity"]');
        const quantity = String(offerQuantity(offer));
        if (quantityInput && quantityInput.value !== quantity) quantityInput.value = quantity;
      }
      const pack = offerLabel(offerQuantity(offer));
      const size = selectedOfferSizes(offer);
      const price = visiblePrice(offer);
      const choice = [pack, size].filter(Boolean).join(' · ');

      setText(selectionSummary?.querySelector('[data-k-selection-choice]'), choice);
      setText(selectionSummary?.querySelector('[data-k-selection-price]'), price);
      setText(stickyPurchase?.querySelector('[data-k-sticky-pack]'), pack);
      setText(stickyPurchase?.querySelector('[data-k-sticky-selection]'), size || pack);
      setText(stickyPurchase?.querySelector('[data-k-sticky-price]'), price);
    };

    const scheduleUpdate = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(update);
    };

    // Keep Dawn's single submission/error/cart flow. The offer is presentation;
    // its selected quantities and variants must also reach the actual FormData.
    let variants;
    let variantsRequest;
    let awaitingVariants = false;
    const optionKey = (values) => values.map((value) => normalizeSize(value).toLowerCase()).join('|');
    const mainOptions = () => {
      const radios = [...productInfo.querySelectorAll('.product-form__input input[type="radio"]:checked')];
      return radios.length ? radios.map((input) => input.value)
        : [...productInfo.querySelectorAll('.product-form__input select')].map((select) => select.value);
    };
    const loadVariants = () => {
      if (!variantsRequest) {
        const url = new URL(productPath, window.location.origin);
        url.pathname = url.pathname.replace(/\/$/, '') + '.js';
        url.search = '';
        variantsRequest = fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then((response) => {
            if (!response.ok) throw new Error('Variant lookup failed');
            return response.json();
          }).then((product) => {
            if (!Array.isArray(product.variants)) throw new Error('Missing variants');
            variants = product.variants;
          }).catch((error) => {
            variantsRequest = undefined;
            throw error;
          });
      }
      return variantsRequest;
    };
    const orderItems = (form) => {
      const offer = selectedOffer();
      const id = form.elements.namedItem('id')?.value;
      const quantity = offerQuantity(offer);
      if (!id || !Number.isInteger(quantity) || quantity < 1) throw new Error('Invalid product selection');
      const rows = isBundle ? [] : [...(offer?.querySelectorAll('.Avada-Volume__Product') || [])];
      if (!rows.length) return [{ id, quantity }];
      const nativeKey = optionKey(mainOptions());
      const items = new Map();
      for (const row of rows) {
        const values = [...row.querySelectorAll('.Avada-VariantSelection__SelectedText')].map((el) => el.textContent);
        const key = optionKey(values);
        let variantId = id;
        if (values.length && key !== nativeKey) {
          if (!variants) return null;
          const variant = variants.find((item) => optionKey(item.options) === key);
          if (!variant || !variant.available) throw new Error('Unavailable product selection');
          variantId = String(variant.id);
        }
        items.set(variantId, (items.get(variantId) || 0) + 1);
      }
      return [...items].map(([variantId, count]) => ({ id: variantId, quantity: count }));
    };
    const purchaseForm = (target) => target instanceof HTMLFormElement &&
      target.matches('form[data-type="add-to-cart-form"]') && productInfo.contains(target);
    const showSelectionError = (form) => {
      let error = form.parentElement.querySelector('[data-k-selection-error]');
      if (!error) {
        error = document.createElement('p');
        error.dataset.kSelectionError = '';
        error.setAttribute('role', 'alert');
        error.className = 'product-form__error-message';
        form.before(error);
      }
      error.textContent = locale === 'de'
        ? 'Die gewählten Größen konnten nicht bestätigt werden. Bitte prüfen Sie Ihre Auswahl und versuchen Sie es erneut.'
        : locale === 'en'
          ? 'We could not confirm the selected sizes. Please check your selection and try again.'
          : 'Izbranih velikosti ni bilo mogoče potrditi. Preverite izbiro in poskusite znova.';
      error.hidden = false;
    };
    productInfo.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!purchaseForm(form) || !selectedOffer()) return;
      if (awaitingVariants) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      update(); // Also covers submitting before the next animation frame.
      form.parentElement.querySelector('[data-k-selection-error]')?.setAttribute('hidden', '');
      try {
        if (orderItems(form)) return;
      } catch (_error) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showSelectionError(form);
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      awaitingVariants = true;
      const button = event.submitter || form.querySelector('[type="submit"]');
      button?.setAttribute('aria-busy', 'true');
      try {
        await loadVariants();
        awaitingVariants = false;
        if (form.isConnected) form.requestSubmit(button || undefined);
      } catch (_error) {
        showSelectionError(form);
      } finally {
        awaitingVariants = false;
        button?.removeAttribute('aria-busy');
      }
    }, true);
    productInfo.addEventListener('formdata', (event) => {
      if (!purchaseForm(event.target) || !selectedOffer()) return;
      const data = event.formData;
      let items;
      try { items = orderItems(event.target); } catch (_error) { /* fail closed below */ }
      if (!items) {
        data.delete('id');
        data.delete('quantity');
        return;
      }
      if (items.length === 1) {
        data.set('id', items[0].id);
        data.set('quantity', String(items[0].quantity));
        return;
      }
      const properties = [...data.entries()].filter(([key]) => /^properties\[.+\]$/.test(key));
      const sellingPlan = data.get('selling_plan');
      data.delete('id');
      data.delete('quantity');
      data.delete('selling_plan');
      properties.forEach(([key]) => data.delete(key));
      items.forEach((item, index) => {
        data.set(`items[${index}][id]`, item.id);
        data.set(`items[${index}][quantity]`, String(item.quantity));
        if (sellingPlan) data.set(`items[${index}][selling_plan]`, sellingPlan);
        properties.forEach(([key, value]) => {
          data.set(`items[${index}][properties][${key.slice(11, -1)}]`, value);
        });
      });
    });

    productInfo.addEventListener('change', scheduleUpdate);
    productInfo.addEventListener('click', scheduleUpdate);
    new MutationObserver(scheduleUpdate).observe(productInfo, {
      attributes: true,
      attributeFilter: ['class', 'aria-checked'],
      childList: true,
      subtree: true,
      characterData: true,
    });

    scheduleUpdate();
  };

  const initCartMoneyFormatting = () => {
    if (!document.body.classList.contains('template-cart')) return;
    const cart = document.querySelector('main');
    if (!cart) return;
    let scheduled = false;
    const update = () => {
      scheduled = false;
      const totalElement = cart.querySelector('.totals__total-value');
      const empty = cart.querySelector('cart-items')?.classList.contains('is-empty') || !cart.querySelector('.cart-item');
      const shipping = cart.querySelector('[data-k-shipping-threshold]');
      if (shipping && totalElement?.hasAttribute('data-k-total-cents')) {
        const threshold = Number(shipping.dataset.kShippingThreshold);
        const total = Number(totalElement.dataset.kTotalCents);
        if (threshold > 0 && Number.isFinite(total)) {
          const remaining = Math.max(0, threshold - total);
          const progress = Math.min(100, Math.floor(total * 100 / threshold));
          shipping.hidden = empty;
          const label = shipping.querySelector('[data-k-shipping-label]');
          const amount = shipping.querySelector('[data-k-shipping-remaining]');
          const reached = shipping.querySelector('[data-k-shipping-reached]');
          if (label) label.hidden = remaining === 0;
          if (amount) {
            amount.hidden = remaining === 0;
            const text = formatEuroAmount(remaining / 100);
            if (amount.textContent !== text) amount.textContent = text;
          }
          if (reached) reached.hidden = remaining > 0;
          shipping.querySelector('[role="progressbar"]')?.setAttribute('aria-valuenow', String(progress));
          shipping.querySelector('.k-cart-shipping__track > span')?.style.setProperty('--k-cart-progress', `${progress}%`);
          const completion = cart.querySelector('.k-cart-completion');
          if (completion) completion.hidden = empty || remaining === 0;
        }
      }
      const sticky = cart.querySelector('.k-cart-sticky-checkout');
      if (sticky) {
        sticky.style.display = empty ? 'none' : '';
        sticky.inert = empty;
        const button = sticky.querySelector('[name="checkout"]');
        if (button) button.disabled = empty;
        const total = totalElement?.textContent;
        const summary = sticky.querySelector('strong');
        if (!empty && total && summary && summary.textContent !== total) summary.textContent = total;
      }
      formatPriceNodes(cart);
    };
    const observer = new MutationObserver(() => {
      if (!scheduled) { scheduled = true; window.requestAnimationFrame(update); }
    });
    observer.observe(cart, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'data-k-total-cents'] });
    update();
  };

  const initStorePriceFormatting = () => {
    const selector = priceTextSelector;
    let scheduled = false;
    const update = () => {
      scheduled = false;
      formatPriceNodes(document);
    };
    const observer = new MutationObserver((mutations) => {
      const relevant = mutations.some((mutation) => {
        const target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        return target?.closest(selector) || [...mutation.addedNodes].some((node) =>
          node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
        );
      });
      if (relevant && !scheduled) { scheduled = true; window.requestAnimationFrame(update); }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    update();
  };

  const initCinematicLayer = () => {
    // Photographs stay sharp and visible during scrolling. The process story
    // keeps its own focused transition, without a second image-reveal layer.
    document.querySelectorAll('[data-k-cine]').forEach((el) => el.classList.add('is-inview'));
  };

  const initOriginVideo = () => {
    document.querySelectorAll('.k-origin-journal__video').forEach((video) => {
      video.defaultMuted = true;
      video.muted = true;

      const play = () => {
        const playback = video.play();
        if (playback) playback.catch(() => {});
      };

      video.addEventListener('canplay', play, { once: true });

      if (!('IntersectionObserver' in window)) {
        play();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) play();
            else video.pause();
          });
        },
        { threshold: 0.12 }
      );

      observer.observe(video);
    });
  };

  const initProcessStory = () => {
    document.querySelectorAll('[data-k-story]').forEach((story) => {
      if (story.dataset.kStoryReady === 'true') return;
      story.dataset.kStoryReady = 'true';

      const steps = [...story.querySelectorAll('[data-story-step]')];
      if (!steps.length) return;

      const sticky = story.querySelector('.k-process-story__sticky');
      const canvas = story.querySelector('.k-process-story__canvas');
      const figures = [...story.querySelectorAll('[data-story-figure]')];
      const progressItems = [...story.querySelectorAll('[data-story-progress-item]')];
      const jumps = [...story.querySelectorAll('[data-story-jump]')];
      const count = story.querySelector('[data-story-count]');
      const ghost = story.querySelector('[data-story-ghost]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const total = steps.length;

      progressItems.forEach((item, index) => {
        const image = figures[index]?.querySelector('img');
        const source = image?.currentSrc || image?.src;
        if (source) item.style.setProperty('--k-progress-image', `url("${source.replaceAll('"', '%22')}")`);
      });

      let current = -1;
      let leavingTimer;
      const setActive = (index) => {
        const next = Math.max(0, Math.min(total - 1, index));
        if (next === current) return;

        const outgoing = figures[current];
        const incoming = figures[next];
        window.clearTimeout(leavingTimer);
        figures.forEach((figure) => figure.classList.remove('is-leaving'));

        if (outgoing && outgoing !== incoming && !reduceMotion) {
          outgoing.classList.remove('is-visible');
          outgoing.classList.add('is-leaving');
          leavingTimer = window.setTimeout(() => outgoing.classList.remove('is-leaving'), 850);
        } else if (outgoing) {
          outgoing.classList.remove('is-visible', 'is-leaving');
        }

        incoming?.classList.remove('is-leaving');
        incoming?.classList.add('is-visible');
        current = next;
        story.dataset.activeStep = String(next);
        story.style.setProperty('--k-story-progress', `${((next + 0.5) / total) * 100}%`);

        steps.forEach((step, i) => step.classList.toggle('is-active', i === next));
        progressItems.forEach((item, i) => {
          item.classList.toggle('is-active', i === next);
          item.classList.toggle('is-complete', i < next);
          const button = item.querySelector('[data-story-jump]');
          if (i === next) button?.setAttribute('aria-current', 'step');
          else button?.removeAttribute('aria-current');
        });

        const visibleNumber = String(next + 1).padStart(2, '0');
        const totalNumber = String(total).padStart(2, '0');
        if (count) count.textContent = `${visibleNumber} / ${totalNumber}`;
        if (ghost) ghost.textContent = visibleNumber;
      };

      const pickStep = () => {
        ticking = false;
        const stickyRect = sticky?.getBoundingClientRect();
        const mobileAnchor = stickyRect
          ? stickyRect.bottom + Math.max(0, window.innerHeight - stickyRect.bottom) * 0.48
          : window.innerHeight * 0.76;
        const canvasRect = canvas?.getBoundingClientRect();
        const desktopAnchor = canvasRect ? (canvasRect.top + canvasRect.bottom) / 2 : window.innerHeight * 0.58;
        const mid = window.innerWidth < 990 ? Math.min(window.innerHeight * 0.84, mobileAnchor) : desktopAnchor;
        let best = 0;
        let bestDist = Infinity;
        steps.forEach((step, i) => {
          const rect = step.getBoundingClientRect();
          const dist = Math.abs(rect.top + rect.height / 2 - mid);
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        });
        setActive(best);
      };

      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(pickStep);
      };

      setActive(0);
      pickStep();

      jumps.forEach((button) => {
        button.addEventListener('click', () => {
          const index = Number(button.dataset.stepIndex);
          const step = steps[index];
          if (!step) return;

          if (window.innerWidth < 990 && sticky) {
            const stickyHeight = sticky.getBoundingClientRect().height;
            const offset = Math.min(window.innerHeight * 0.66, stickyHeight + 76);
            const top = window.scrollY + step.getBoundingClientRect().top - offset;
            window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
          } else if (canvas && sticky) {
            const stickyRect = sticky.getBoundingClientRect();
            const canvasRect = canvas.getBoundingClientRect();
            const stepRect = step.getBoundingClientRect();
            const pinnedTop = Number.parseFloat(window.getComputedStyle(sticky).top) || 0;
            const anchor = pinnedTop + canvasRect.top - stickyRect.top + canvasRect.height / 2;
            const top = window.scrollY + stepRect.top + stepRect.height / 2 - anchor;
            window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
          } else {
            step.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          }
        });
      });

      if (!('IntersectionObserver' in window)) {
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        return;
      }

      const gate = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              window.addEventListener('scroll', onScroll, { passive: true });
              window.addEventListener('resize', onScroll, { passive: true });
              onScroll();
            } else {
              window.removeEventListener('scroll', onScroll);
              window.removeEventListener('resize', onScroll);
            }
          });
        },
        { rootMargin: '25% 0px 25% 0px' }
      );

      gate.observe(story);
    });
  };

  const initConversionSignals = () => {
    const context = {
      locale: document.documentElement.lang?.slice(0, 2) || 'sl',
      device: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
    };
    const emit = (name, detail = {}) => {
      const payload = { event: `kosale_${name}`, ...context, ...detail };
      window.dispatchEvent(new CustomEvent('kosale:conversion', { detail: payload }));
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
    };

    const productInfo = document.querySelector('.k-field-notes-product');
    if (productInfo) {
      const productTitle = productInfo.querySelector('.product__title')?.textContent?.replace(/\s+/g, ' ').trim();
      const productHandle = location.pathname.split('/products/')[1]?.split(/[/?#]/)[0] || '';
      const selectedVariant = () => productInfo.querySelector('form[action*="/cart/add"] input[name="id"]')?.value || '';

      emit('product_view', { product_handle: productHandle, product_title: productTitle });

      productInfo.addEventListener('change', (event) => {
        const control = event.target;
        if (!(control instanceof HTMLInputElement || control instanceof HTMLSelectElement)) return;
        if (control.closest('.Avada-VolumeItem__Container')) {
          emit('tier_selection', {
            product_handle: productHandle,
            selection: control.getAttribute('aria-label') || control.value || control.textContent?.trim(),
          });
          return;
        }
        if (control.closest('variant-selects, variant-radios, .product-form__input')) {
          emit('size_selection', {
            product_handle: productHandle,
            option_name: control.name,
            option_value: control.value,
            variant_id: selectedVariant(),
          });
        }
      });

      productInfo.querySelector('[id^="ProductSubmitButton-"]')?.addEventListener('click', () => {
        emit('add_to_cart', { product_handle: productHandle, variant_id: selectedVariant() });
      });
    }

    if (document.body.classList.contains('template-cart')) {
      const cartTotal = document.querySelector('.totals__total-value')?.textContent?.replace(/\s+/g, ' ').trim();
      emit('cart_view', { cart_total: cartTotal });
      document.addEventListener('click', (event) => {
        const checkout = event.target instanceof Element ? event.target.closest('[name="checkout"]') : null;
        if (checkout) emit('checkout_started', { cart_total: cartTotal });
      });
    }
  };


  const initAovVolumeDiscountFallback = () => {
    const offerId = 'itsaK4ZE5Khspu459kkz';
    const propertyName = 'properties[_aov_bundles]';
    const propertyKey = '_aov_bundles';
    const propertyValue = JSON.stringify({ offerId });

    const tagProductForm = (form) => {
      if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]')) return;

      let field = [...form.elements].find((element) => element.name === propertyName);
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = propertyName;
        form.appendChild(field);
      }
      field.value = propertyValue;
    };

    const tagProductForms = (root = document) => {
      if (root instanceof HTMLFormElement) tagProductForm(root);
      root.querySelectorAll?.('form[action*="/cart/add"]').forEach(tagProductForm);
    };

    tagProductForms();

    document.addEventListener(
      'submit',
      (event) => {
        if (event.target instanceof HTMLFormElement) tagProductForm(event.target);
      },
      true
    );

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) tagProductForms(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });

    if (!document.body.classList.contains('template-cart')) return;

    const repairExistingCart = async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const cart = await fetch(root + 'cart.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        }).then((response) => {
          if (!response.ok) throw new Error('Unable to read cart');
          return response.json();
        });

        const missing = cart.items.filter((item) => !item.properties?.[propertyKey]);
        if (!missing.length) {
          sessionStorage.removeItem('kosale:aov-cart-repair');
          return;
        }

        const repairKey = cart.token + ':' + missing.map((item) => item.key + ':' + item.quantity).join('|');
        if (sessionStorage.getItem('kosale:aov-cart-repair') === repairKey) return;
        sessionStorage.setItem('kosale:aov-cart-repair', repairKey);

        for (const item of missing) {
          const properties = { ...(item.properties || {}), [propertyKey]: propertyValue };
          const response = await fetch(root + 'cart/change.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              id: item.key,
              quantity: item.quantity,
              properties,
            }),
          });
          if (!response.ok) throw new Error('Unable to update cart item');
        }

        window.location.reload();
      } catch (error) {
        console.warn('Košale: automatic volume discount metadata could not be refreshed.', error);
      }
    };

    repairExistingCart();
  };

  const init = () => {
    document.querySelectorAll('[data-k-sticky-purchase]').forEach(syncStickyPurchase);
    document.querySelectorAll('.k-field-notes-product').forEach(chooseSingleJarOffer);
    document.querySelectorAll('.k-field-notes-product').forEach(initPurchaseSelection);
    initCartMoneyFormatting();
    initStorePriceFormatting();
    initCinematicLayer();
    initOriginVideo();
    initProcessStory();
    initConversionSignals();
    initAovVolumeDiscountFallback();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
